import ConfirmDelete from "./confirm-delete.container";

export default ConfirmDelete;
